export default __webpack_public_path__ + "static/media/icon_medic.8b941414.png";